import { produce } from 'immer';
import { Reducer } from 'redux';
import { EditTagsDrawerActions } from '~/components/containers/EditTagsDrawerContainer/actions';
import EditTagsDrawerConstants from './constants';
import { EditTagsDrawerState, initialEditTagsDrawerState } from './data/EditTagsDrawerState';

const reducer: Reducer<EditTagsDrawerState, EditTagsDrawerActions> = (
  state = initialEditTagsDrawerState,
  action
) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case EditTagsDrawerConstants.OPEN_EDIT_TAGS_DRAWER: {
        draft.isEditTagsDrawerOpen = true;
        break;
      }
      case EditTagsDrawerConstants.CLOSE_EDIT_TAGS_DRAWER: {
        draft.isEditTagsDrawerOpen = false;
        break;
      }
      case EditTagsDrawerConstants.OPEN_DELETE_CATEGORY_MODAL: {
        const { payload } = action;
        draft.deleteCategoryModalIsOpen = true;
        draft.deleteCategoryModalItem = payload.tagCategory;
        break;
      }
      case EditTagsDrawerConstants.CLOSE_DELETE_CATEGORY_MODAL:
        draft.deleteCategoryModalItem = undefined;
        draft.deleteCategoryModalIsOpen = false;
        break;
      case EditTagsDrawerConstants.OPEN_DELETE_TAG_MODAL: {
        const { payload } = action;
        draft.deleteTagModalIsOpen = true;
        draft.deleteTagModalItem = payload.tag;
        break;
      }
      case EditTagsDrawerConstants.CLOSE_DELETE_TAG_MODAL:
        draft.deleteTagModalItem = undefined;
        draft.deleteTagModalIsOpen = false;
        break;
      default:
        return state;
    }
  });
};

export default reducer;
